<template>
    <label class="form__control">
        <span class="form__label">{{ label }}</span>
        <select :multiple="multiple" :placeholder="placeholder" ref="selectize" v-model="model" class="form__select">
            <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.label }}
            </option>
        </select>
    </label>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue'
import $ from 'jquery'

const props = defineProps({
    options: {
        type: Array,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    multiple: {
        type: Boolean,
        default: true
    },
    label: {
        type: String,
        required: true
    },
    placeholder: {
        type: String,
        default: 'Select some options'
    }
})

const model = defineModel();
const selectize = ref(null)



onMounted(() => {
    const select = $(selectize.value).selectize({
        onChange:(value)=> model.value = value
    })[0].selectize;

	watch(model, (value) => {
		select.setValue(value,true);
	});
})


</script>
